export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      // console.log("APP_LOGIN_SUCCESS");
      // console.log(localStorage.getItem('token'));
      this.$router.replace({ name: 'attendance/personal' });
    }
  },
  {
    name: 'APP_LOGIN_FAILED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Usuario y/o contraseña invalidos.'
      };
      localStorage.removeItem('token');
      this.$router.push({ path: '/login' });
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'orange',
        text: 'Sesión cerrada.'
      };
      localStorage.removeItem('token');
      this.$router.replace({ path: '/login' });
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: 'Sesión expirada.'
      };
      this.$router.push('/login');
      //this.$message.error('Token has expired');
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'red',
        text: msg
      };
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'info',
        text: msg
      };
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.snackbar = {
        show: true,
        color: 'success',
        text: msg
      };
    }
  },

];
